import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcIconButton } from '@one/react';

export type PocIconButtonProps = ComponentPropsWithoutRef<typeof OwcIconButton>;

export const PocIconButton = forwardRef<ElementRef<typeof OwcIconButton>, PocIconButtonProps>((props, ref) => (
    <OwcIconButton ref={ref} {...props} />
));

PocIconButton.displayName = 'PocIconButton';
